import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_9 = { class: "dropdown" }
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_16 = { class: "mb-0 text-paragraph" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "mt-15 mt-md-0" }
const _hoisted_20 = { class: "pagination mb-0" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary text-black",
          to: "/ajouter-ouvfer"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
            _createTextVNode(" Ouverture de caisse ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-bg svg-color pt-3",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black",
            placeholder: "Rechercher caisse"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { scope: "col" }, "Caisse"),
              _createElementVNode("th", { scope: "col" }, "Fond de roulement"),
              _createElementVNode("th", { scope: "col" }, "Solde"),
              _createElementVNode("th", { scope: "col" }, "Statut"),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ouvFers, (ouvFer) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: ouvFer.id
              }, [
                _createElementVNode("th", null, _toDisplayString(ouvFer.caisse?.nom ?? 'N/A'), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.separateur(ouvFer.fondsRoulement)), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.separateur(ouvFer.solde)), 1),
                _createElementVNode("th", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
                    'badge fs-15',
                    ouvFer.status === 'Fermé' || ouvFer.status === 'FERMER' ? 'bg-danger' : 'bg-success'
                  ])
                  }, _toDisplayString(ouvFer.status || 'Ouvert'), 3)
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[13] || (_cache[13] = _createElementVNode("button", {
                      class: "btn dropdown-toggle btn-primary text-black",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, "Actions", -1)),
                    _createElementVNode("ul", _hoisted_10, [
                      (ouvFer.status === 'OUVERTE')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                            _createVNode(_component_router_link, {
                              to: `/ajouter-fer/${ouvFer.id}`,
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "flaticon-lock lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Fermer la caisse ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : (_openBlock(), _createElementBlock("li", _hoisted_12, [
                            _createVNode(_component_router_link, {
                              to: "/ajouter-ouvfer",
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("i", { class: "flaticon-lock lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Ouvrir la caisse ")
                              ])),
                              _: 1
                            })
                          ])),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'ViewOuvFermPage', params: { id: ouvFer.id} },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fa flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode("Détails ")
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.voirConfirmation()))
                        }, _cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "flaticon-refresh lh-1 me-2" }, null, -1),
                          _createTextVNode("Voir les reglements ")
                        ]))
                      ]),
                      (ouvFer.ecart !== 0 && !ouvFer.isRegularized)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                            _createElementVNode("a", {
                              class: "dropdown-item d-flex align-items-center",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.handleRegularisation(ouvFer))
                            }, _cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "flaticon-refresh lh-1 me-2" }, null, -1),
                              _createTextVNode("Régulariser ")
                            ]), 8, _hoisted_14)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, [
          _cache[15] || (_cache[15] = _createTextVNode(" Affichage de ")),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.ouvFers.length), 1),
          _cache[16] || (_cache[16] = _createTextVNode(" sur ")),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.totalElements), 1),
          _cache[17] || (_cache[17] = _createTextVNode(" résultats "))
        ]),
        _createElementVNode("nav", _hoisted_19, [
          _createElementVNode("ul", _hoisted_20, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                "aria-label": "Previous",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
              ]))
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }]),
                key: page
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
                }, _toDisplayString(page), 9, _hoisted_21)
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                "aria-label": "Next",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
              ]))
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}